import React from "react";
import "./App.css";

import Weather from "./components/Weather";

function App() {
  return (
    <div className="container">
      <Weather></Weather>
    </div>
  );
}

export default App;
